import React from 'react';
var Check = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "13.366", height: "9.544", viewBox: "0 0 13.366 9.544" },
        React.createElement("path", { id: "Path_206", "data-name": "Path 206", d: "M39.767,154.7a1.067,1.067,0,0,1,1.5-1.513l3.053,3.023,6.645-6.645a1.07,1.07,0,0,1,1.512,1.512l-7.4,7.393a1.066,1.066,0,0,1-1.506,0Z", transform: "translate(-39.44 -149.244)" })));
};
Check.defaultProps = {
    className: '',
};
export default Check;
